module.exports = __webpack_public_path__ + "img/6f2a1d8.png";